import type { ApiIdentity, ZudokuPlugin } from "zudoku";
import { getCredentials } from "./credentialsStore";

function toHex(buffer: ArrayBuffer) {
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("");
}

async function hmacSha256Hex(secret: string, message: string) {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const sig = await crypto.subtle.sign("HMAC", key, enc.encode(message));
  return toHex(sig);
}

const arpIdentity: ApiIdentity = {
  id: "arp-hmac",
  label: "ARP API Key (from Signature Generator)",
  authorizationFields: {
    headers: ["x-api-key", "x-timestamp", "x-signature"],
  },
  authorizeRequest: async (request: Request) => {
    const creds = getCredentials();
    if (!creds) return request;

    const timestamp = Math.floor(Date.now() / 1000).toString();
    const rawBody = await request.clone().text();
    const message = creds.apiKey + rawBody + timestamp;
    const signature = await hmacSha256Hex(creds.apiSecret, message);

    // Mutate headers in-place — Zudoku discards the return value of authorizeRequest
    request.headers.set("x-api-key", creds.apiKey);
    request.headers.set("x-timestamp", timestamp);
    request.headers.set("x-signature", signature);

    return request;
  },
};

export const arpAuthPlugin: ZudokuPlugin = {
  getIdentities: async () => [arpIdentity],
};
